// ** Initial State
const initialState = {
  allData: [],
  data: null,
  pricing: [],
  reconciliation_data:[]
}

const registrationRecords = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_REG':
      return { ...state, allData: action.data }
   
    case 'GET_REG':
      return { ...state, data: action.data }

    case 'GET_ALL_PRICING':
      return { ...state, pricing: action.data }

    case 'GET_RECONCILIATION_REPORT':
      return { ...state, reconciliation_data: action.data }

    default:
      return { ...state }
  }
}
export default registrationRecords
